import React from "react";

const SeenAllFeeds: React.FC = () => {
  return (
    <div className="relative z-10 flex items-center justify-center h-screen bg-cover bg-center bg-no-repeat bg-white">
      {/* Content */}
      <div className="relative flex flex-col items-center text-center px-4">
        {/* Party Popper Emoji */}
        <div className="text-6xl mb-4">🎉</div>

        {/* Message */}
        <p className="text-[#1F2933] text-xl font-medium leading-6">
          You’ve seen all your feeds for today! Check back later for more
          updates.
        </p>
      </div>
    </div>
  );
};

export default SeenAllFeeds;
